import 'intersection-observer';
import './stickyNav.css';
import './stickyNav.html.twig';

export default function() {
  const indicator = document.querySelector('.sticky-nav');
  if (!indicator) {
    return;
  }

  indicator.addEventListener('click', e => {
    if (window.matchMedia('(max-width: 992px)').matches) {
      e.preventDefault();
      indicator.classList.toggle('sticky-nav--open');
    }
  });

  const links = indicator.querySelector('.sticky-nav__links');
  const elements = [...indicator.parentElement.children].filter(e => e.querySelector('h2'));

  renderIndicator(links, elements, 0);

  const observer = new IntersectionObserver(
    entries => {
      const activated = entries.reduce((max, entry) => (entry.intersectionRatio > max.intersectionRatio ? entry : max));
      if (activated.isIntersecting) {
        renderIndicator(links, elements, elements.findIndex(e => e === activated.target));
      }
    },
    {
      rootMargin: '-25% 0% -65% 0%',
    }
  );

  observer.POLL_INTERVAL = 100;
  elements.forEach(e => observer.observe(e));

  function renderIndicator(indicator, elements, activeElement) {
    indicator.innerHTML = '';
    elements.forEach((element, i) => {
      const label = makeIndicator(element.querySelector('h2').innerText, i === activeElement, () => {
        element.scrollIntoView();
        window.scrollBy(0, -150);
        renderIndicator(links, elements, i);
      });
      indicator.appendChild(label);
    });
  }
}

function makeIndicator(title, isActive, handleClick) {
  const label = document.createElement('label');
  label.classList.add('sticky-nav__label');
  label.title = title;
  label.onclick = handleClick;

  const radio = document.createElement('input');
  radio.type = 'radio';
  radio.name = 'sticky-nav';
  radio.checked = isActive;
  label.appendChild(radio);

  const checkmark = document.createElement('span');
  checkmark.classList.add('sticky-nav__checkmark');
  label.appendChild(checkmark);

  const desc = document.createElement('span');
  desc.classList.add('sticky-nav__description');
  desc.innerHTML = title;
  label.appendChild(desc);

  const arrow = document.createElement('span');
  arrow.innerHTML =
    '<svg class="sticky-nav__arrow" width="16" height="22" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M.5.5h21v15H.5z"/></defs><g transform="rotate(90 8 8)" fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M21.178 7.225L14.752.821a1.103 1.103 0 0 0-1.556 0 1.094 1.094 0 0 0 0 1.55l4.549 4.533H1.6C.992 6.904.5 7.394.5 8c0 .605.492 1.096 1.1 1.096h16.145l-4.549 4.533a1.093 1.093 0 0 0 0 1.55 1.1 1.1 0 0 0 1.556 0l6.426-6.404c.43-.428.43-1.122 0-1.55" mask="url(#b)"/></g></svg>';

  label.appendChild(arrow.firstChild);

  if (isActive) {
    label.classList.add('sticky-nav__label--active');
  }

  return label;
}
